import React, { useEffect, useState } from "react";

export function Agenda({ className, children }) {
  return (
    <section className={`${className} bg-purple`}>
      <div className="container pb-5">{children}</div>
    </section>
  );
}

export function AgendaDay({ title, children }) {
  return (
    <div className="mt-5">
      <div className="text-center mb-3 agenda-day">
        <h1 className="color-white">{title}</h1>
      </div>
      <div className="banded-rows">{children}</div>
    </div>
  );
}

export function AgendaEvent({ time, title, children, isKeynote }) {
  return (
    <div className="row align-items-baseline">
      <div className="col-lg-2 p-lg-0 offset-lg-1 text-nowrap flex-shrink-1 flex-grow-0">
        <span className="time">{time}</span>
      </div>
      <div className="col p-lg-0 flex-grow-1 flex-shrink-0">
        {isKeynote && <span className="color-white-60">Keynote Speaker</span>}
        <h3 className="mb-2">{title}</h3>
        {children}
      </div>
    </div>
  );
}

export function AgendaSpeaker({ name, company, className }) {
  const [imageSrc, setImageSrc] = useState("/img/portrait-tba.webp");

  useEffect(() => {
    if (!name) return;

    const formattedName = name
      .toLowerCase()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-");

    const imagePath = `/img/portrait-${formattedName}.webp`;
    const img = new Image();
    img.src = imagePath;

    img.onload = () => setImageSrc(imagePath);
    img.onerror = () => setImageSrc("/img/portrait-tba.webp");
  }, [name]);

  return (
    <span className={`agenda-speaker ${className}`}>
      <div
        className="agenda-speaker-img"
        style={{ backgroundImage: `url(${imageSrc})` }}
      ></div>
      <strong>{name}</strong>
      {company && <span className="company white-60">({company})</span>}
    </span>
  );
}

export function AgendaBreakout({ title, count }) {
  if (!count) return null;

  return (
    <div className="breakout-row">
      <span className="color-white-60">Breakout Session {count}</span>
      <h3 className="mb-2">{title}</h3>
    </div>
  );
}
